/* ==========================================
   260305 カスタムjs（全機能統合・完全復旧版）
   ========================================== */

(function ($) {
	$(function () {
		// GSAPプラグインの有効化
		if (typeof ScrollTrigger !== 'undefined') {
			gsap.registerPlugin(ScrollTrigger);
		}

		/**
		 * 1. ヘッダー：スクロール制御
		 */
		function toggleHeaderClass() {
			if ($(window).scrollTop() > 20) {
				$('.site-header').addClass('scrolled');
			} else {
				$('.site-header').removeClass('scrolled');
			}
		}
		$(window).on('scroll', toggleHeaderClass);
		toggleHeaderClass();

		/**
		 * 2. アニメーション関数定義
		 */
		// ① 図解レイヤーのアニメーション
		function playModalAnimation(selector) {
			const container = document.querySelector(selector);
			if (!container) return;
			const imgs = container.querySelectorAll('.visual-img');
			gsap.set(imgs, { opacity: 0 });
			const tl = gsap.timeline();
			imgs.forEach((img, i) => {
				tl.set(img, { zIndex: i + 1 })
					.to(img, { opacity: 1, duration: 0.5, ease: 'power1.inOut' })
					.to({}, { duration: 1.2 });
			});
		}

		// ② 棒グラフのアニメーション
		function animateCharts(el) {
			const bars = el.querySelectorAll('.js-bar');
			if (bars.length === 0) return;
			bars.forEach((bar) => {
				const val = bar.getAttribute('data-width');
				const pct = (parseInt(val) / 221) * 100;
				gsap.fromTo(bar, { width: '0%' }, { width: pct + '%', duration: 1.5, ease: 'expo.out' });
			});
		}

		/**
		 * 3. 実行部分（モーダル制御）
		 */
		$(document).on('shown.bs.modal', '.modal', function () {
			const modalId = $(this).attr('id');
			// ① 図解
			playModalAnimation('#' + modalId + ' .js-visual-layer');
			// ② 棒グラフ
			animateCharts(this);
		});

		/**
		 * 4. コーポレートトップ演出
		 * 採用ページ（.rec-top_1がある時）は、この4番の処理全体を完全にスキップさせます。
		 */
		if ($('.js-top-bg1').length && !$('.rec-top_1').length) {
			// ここに元の4番のGSAP処理をすべて入れる
			gsap.set('.js-top-bg1', { opacity: 1 });
			gsap.set('.js-top-bg2', { opacity: 0 });

			const topTl = gsap.timeline({ delay: 0.5 });
			topTl
				.fromTo(
					'.top-topimg h1.display-1',
					{ opacity: 0, y: 40 },
					{ opacity: 1, y: 0, duration: 1.0, ease: 'power3.out', clearProps: 'transform' },
					'-=0.2',
				)
				.fromTo(
					'.top-topimg p.small',
					{ opacity: 0, y: 30 },
					{ opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', clearProps: 'transform' },
					'-=0.4',
				)
				.fromTo(
					'.top-topimg .mission, .top-topimg p.fs-5, .viewmore',
					{ opacity: 0, y: 20 },
					{ opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out', clearProps: 'transform' },
					'-=0.4',
				)
				.to('.js-top-scroll', { opacity: 1, duration: 0.8 }, '-=0.2')
				.to('.js-top-bg2', { opacity: 1, duration: 1.5 }, '+=1.5')
				.to('.js-top-bg1', { opacity: 0, duration: 1.5 }, '-=1.5');

			gsap.fromTo('.js-scroll-bar', { y: '-100%' }, { y: '100%', duration: 2, ease: 'power1.inOut', repeat: -1 });
		}

		/**
		 * 5. 採用トップ演出（位置補正のみ）
		 */
		if ($('.rec-top_1').length) {
			const hasHash = window.location.hash;

			// 演出用クラスの付与（CSSアニメーション起動）
			$('.rec-top_1').addClass('is-active');

			// 【PCで途中で止まる現象への対策】
			// 自力で動かそうとせず、ブラウザに「正しい位置」を再認識させるだけ
			if (hasHash && $(hasHash).length) {
				// ページ読み込みが完全に終わったタイミングで、URLの場所に強制ジャンプさせる
				$(window).on('load', function () {
					setTimeout(function () {
						const target = document.querySelector(hasHash);
						if (target) {
							target.scrollIntoView({ behavior: 'auto', block: 'start' });
						}
					}, 100);
				});
			}

			// スライドイン演出（これは維持）
			$('.rec-top_2 .rec-line').each(function () {
				gsap.fromTo(
					this,
					{ opacity: 0, y: 50 },
					{
						opacity: 1,
						y: 0,
						duration: 0.8,
						ease: 'power2.out',
						scrollTrigger: { trigger: this, start: 'top 90%', toggleActions: 'play none none none' },
					},
				);
			});
		}
		/**
		 * 6. 数字のカウントアップ
		 */
		const countTargets = document.querySelectorAll('.js-count-up');
		countTargets.forEach((el) => {
			const targetValue = { val: 0 };
			const endValue = parseInt(el.getAttribute('data-target'));
			gsap.to(targetValue, {
				val: endValue,
				duration: 2,
				ease: 'power1.out',
				scrollTrigger: {
					trigger: el,
					start: 'top 85%',
					toggleActions: 'play none none none',
				},
				onUpdate: () => {
					el.innerText = Math.floor(targetValue.val).toLocaleString();
				},
				onComplete: () => {
					if (endValue >= 10000) {
						gsap.to('#plus-sign', {
							opacity: 1,
							duration: 0.5,
							x: 5,
							ease: 'back.out(1.7)',
						});
					}
				},
			});
		});

		/**
		 * 7. スライドインアニメーション (.slidein)
		 */
		document.querySelectorAll('.slidein').forEach((el) => {
			gsap.fromTo(
				el,
				{ opacity: 0, y: 40 },
				{
					opacity: 1,
					y: 0,
					duration: 1,
					ease: 'power2.out',
					scrollTrigger: {
						trigger: el,
						start: 'top 85%',
						toggleActions: 'play none none none',
					},
				},
			);
		});

		/**
		 * 8. 共通UI（トップに戻る・スムーススクロール）
		 */
		var topBtn = $('#page-top');
		$(window).on('scroll', function () {
			if ($(this).scrollTop() > 500) {
				topBtn.addClass('show');
			} else {
				topBtn.removeClass('show');
			}
		});

		topBtn.on('click', function (e) {
			e.preventDefault();
			window.scrollTo({ top: 0, behavior: 'smooth' });
		});

		$('a[href^="#"]').on('click', function (e) {
			const href = $(this).attr('href');
			if (href === '#' || href === '') return;
			const target = $(href);
			if (target.length) {
				e.preventDefault();
				const position = target.offset().top - 100; //ページ内リンク限定:100px手前で止まる
				window.scrollTo({ top: position, behavior: 'smooth' });
			}
		});

		/**
		 * 9. スクロールガイド (.top-scroll) のフェードアウト制御（往復対応版）
		 */
		if ($('.top-scroll').length) {
			// 初期状態を表示にセット
			gsap.set('.top-scroll', { opacity: 1, pointerEvents: 'auto' });

			gsap.to('.top-scroll', {
				scrollTrigger: {
					trigger: 'footer',
					start: 'top 95%', // 少し早めに（フッターが5%見えたら）反応させる
					toggleActions: 'play reverse play reverse',
				},
				opacity: 0,
				pointerEvents: 'none',
				duration: 0.3,
			});
		}
	}); // end of jQuery ready
})(jQuery);

/* --- グラフ描画の追加命令（Chart.js） --- */
jQuery(function ($) {
	function runFinalChart(canvas, animate) {
		if (!canvas || canvas.classList.contains('is-initialized')) return;
		var d = canvas.dataset;
		if (!d || !d.values) return;

		new Chart(canvas.getContext('2d'), {
			type: 'doughnut',
			data: {
				datasets: [
					{
						data: d.values.split(',').map(Number),
						// $()を使って確実に属性を取得するように書き換えます
						backgroundColor: $(canvas).attr('data-colors') ? $(canvas).attr('data-colors').split(',') : ['#1a4a6e', '#aec4d7'],
						borderWidth: 1,
						borderColor: '#ffffff',
					},
				],
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				cutout: '70%',
				animation: { animateRotate: animate, duration: animate ? 1000 : 0 },
				plugins: { legend: { display: false } },
			},
		});
		canvas.classList.add('is-initialized');
	}
	$('.js-chartjs').each(function () {
		if ($(this).closest('.modal').length === 0) {
			runFinalChart(this, false);
		}
	});
	$(document).on('shown.bs.modal', '.modal', function () {
		$(this)
			.find('.js-chartjs')
			.each(function () {
				runFinalChart(this, true);
			});
	});
});
